module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.showHeader) ? _c('v-toolbar', {
    staticClass: "cyan darken-3",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Avaliações")])], 1) : _vm._e(), _vm._v(" "), (_vm.showHeader) ? _c('v-card-text', [_vm._v("\n        A avaliação dos examinadores está visível "), _c('strong', [_vm._v("apenas")]), _vm._v(" para o presidente da banca, examinadores, coordenação de curso e coordenação de estágio/TCC.\n        Aos examinadores é disponibilizada para consulta apenas a sua própria avaliação.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.errors == false) ? _c('v-card-title', {
    staticClass: "pa-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "info"
    },
    on: {
      "click": _vm.loadEvaluations
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("refresh")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.errors == false) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "no-data-text": _vm.noData,
      "no-results-text": _vm.noResult,
      "rows-per-page-text": _vm.rowsPerPageT,
      "hide-actions": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: _vm.getExaminerRowClass(props.item)
        }, [_c('td', [_vm._v(_vm._s(_vm.getExaminerName(props.item.examiner)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.finalScore))]), _vm._v(" "), _c('td', {
          attrs: {
            "align": "center"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'examEvaluationDetail',
              params: {
                id: _vm.examId,
                evaluator: props.item.examiner.id
              }
            }
          }
        }, [_c('v-btn', {
          attrs: {
            "color": "info",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Ver ficha de avaliação"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("description")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', {
          class: _vm.getExaminerRowClass(props.item)
        }, [(props.item.notes) ? _c('td', {
          attrs: {
            "colspan": "4"
          }
        }, [_c('strong', [_vm._v("Comentários:")]), _vm._v(" " + _vm._s(props.item.notes) + " \n                ")]) : _vm._e()])]
      }
    }], null, false, 2646817327)
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "totalScore"
  }, [_c('span', [_vm._v("Média Sugerida: " + _vm._s(_vm.totalScore))])]) : _vm._e(), _vm._v(" "), (_vm.interval != null) ? _c('v-card-title', [_c('v-alert', {
    attrs: {
      "color": "info",
      "value": "true"
    }
  }, [_vm._v("\n            Atualizando automaticamente a cada " + _vm._s(_vm.refreshInterval) + " segundos.\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.errors != false) ? _c('v-card-title', _vm._l((_vm.errors), function(error, idx) {
    return _c('v-alert', {
      key: 'error_' + idx,
      attrs: {
        "color": "error",
        "value": "true"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.showActions) ? _c('v-card-actions', [_vm._t("actions")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8144696"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamEvaluations.vue
// module id = 258
// module chunks = 0